import { defineMessages } from 'react-intl';

export default defineMessages({
  policyNumber: {
    id: 'search_bar.policy_number',
  },
  registrationNumber: {
    id: 'search_bar.registration_number',
  },
  lossDate: {
    id: 'search_bar.loss_date',
  },
  claimNumber: {
    id: 'search_bar.claim_number',
  },
});
